export const getClassification = (value) => {
  let classificationValue = value ?? '--';
  let classificationLabel = '--';

  switch (classificationValue) {
    case 'proposal':
      classificationLabel = '제안서';
      break;
    case 'brochure':
      classificationLabel = '브로셔';
      break;
    case 'patch_file':
      classificationLabel = '패치파일';
      break;
    case 'install_file':
      classificationLabel = '설치파일';
      break;
    case 'guide':
      classificationLabel = '가이드문서';
      break;
    default:
      classificationLabel = '--';
      break;
  }

  return classificationLabel;
};
